/**
 * Analytics Singleton
 * Central access point for analytics - delegates to the configured provider
 */

import type {
  AnalyticsProvider,
  AnalyticsProperties,
} from "./AnalyticsProvider";

class AnalyticsService {
  private provider: AnalyticsProvider | null = null;

  /**
   * Initialize with a specific analytics provider
   */
  init(provider: AnalyticsProvider): void {
    this.provider = provider;
    this.provider.init();
  }

  /**
   * Identify a user (call after login)
   */
  identify(userId: string, properties?: AnalyticsProperties): void {
    this.provider?.identify(userId, properties);
  }

  /**
   * Track an event
   */
  track(eventName: string, properties?: AnalyticsProperties): void {
    this.provider?.track(eventName, properties);
  }

  /**
   * Set user properties
   */
  setUserProperties(properties: AnalyticsProperties): void {
    this.provider?.setUserProperties(properties);
  }

  /**
   * Reset analytics state (call on logout)
   */
  reset(): void {
    this.provider?.reset();
  }
}

// Export singleton instance
export const Analytics = new AnalyticsService();
